type Props = {
  width?: string;
  height?: string;
};

/**
 * Filled star icon — used as a "named version" / pinned-checkpoint indicator
 * in the version history panel. Uses currentColor for both fill and stroke.
 */
export function StarFilledIcon({ width = '14', height = '14' }: Props) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M7 1.5L8.7 5L12.5 5.55L9.75 8.2L10.4 12L7 10.2L3.6 12L4.25 8.2L1.5 5.55L5.3 5L7 1.5Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.8"
        strokeLinejoin="round"
      />
    </svg>
  );
}
